import React from "react";

const CloseQSIcon = () => {
  return (
    <div className="qs_close_icon">
      <span className="qs_close_icon_line qs_close_icon_line1"></span>
      <span className="qs_close_icon_line qs_close_icon_line2"></span>
    </div>
  );
};

export default CloseQSIcon;
